import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

const backend = resourcesToBackend((lng: string, ns: string) => {
  return import(`./locales/${lng}/${ns}.json`);
});

i18n
  .use(backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ko", "en"],
    fallbackLng: "ko",
    defaultNS: "common",
    ns: ["common", "careerMap"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "lang",
    },
    react: { useSuspense: true },
  });

export default i18n;
